module.exports = __webpack_public_path__ + "static/gallery_west_street_1-3c15f4a31eba09839e65408801ccfb29.jpg";